import { render, staticRenderFns } from "./WBtnIcon.vue?vue&type=template&id=ae844c70&scoped=true&"
import script from "./WBtnIcon.vue?vue&type=script&lang=js&"
export * from "./WBtnIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae844c70",
  null
  
)

export default component.exports